export default __webpack_public_path__ + "static/media/profile.c1af9fe0.svg";